// @flow

import ConfigActions from '../actions/ConfigActions';
import NotificationActions from "../actions/NotificationActions";
import WebApi from '../WebApi';
import _ from "underscore";

import t from '../trans';

let ConfigSource = {
	fetchConfig() {
		return {
			remote(state) {
				return WebApi.getConfig();
			},
			
			local() {
				return null;
			},
			
			success: ConfigActions.fetchConfigDone,
			error: ConfigActions.fetchConfigFailed
		};
	},

	saveConfig() {
		return {
			remote(state) {
				try {
                    return WebApi.putConfig(state.config);
				} catch (e) {
                    if (!_.isString(e)) {
                        console.log(e.toString());
                        NotificationActions.error.defer(t("Internal error"));
                    }
                    else NotificationActions.error.defer(e);

                    return new Promise((resolve, reject) => {reject(e);});
				}
			},
			
			local() {
				return null;
			},
			
			success: ConfigActions.saveConfigDone,
			error: ConfigActions.saveConfigFailed
		};
	}
};

export default ConfigSource;
